/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BpAddress } from '../../models/bp-address';

export interface FindCpBpAddressesByGuid$Params {
  bpGuid: string;
}

export function findCpBpAddressesByGuid(http: HttpClient, rootUrl: string, params: FindCpBpAddressesByGuid$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BpAddress>>> {
  const rb = new RequestBuilder(rootUrl, findCpBpAddressesByGuid.PATH, 'get');
  if (params) {
    rb.path('bpGuid', params.bpGuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BpAddress>>;
    })
  );
}

findCpBpAddressesByGuid.PATH = '/business-parties/cp/addresses/{bpGuid}';
